export const programs_data = `
Undergraduate Programs
Introduction
The mission of undergradute program is to enhance intellectual and professional competencies by imparting knowledge through a meritorious culture that encourages critical thinking, active learning, ethical consciousness and global awareness.


Course Name	Department	Major	Length
BBA	Business Administration	Marketing
HRM
Finance
4 Years
BBA (Agribusiness)	Business Administration	Agribusiness	4 Years
BS-Computer Science	Computer Science	Computer Science - CS
Software Engineering - SE
4 Years
BSA	Business Administration	Accounting & Finance - AF
4 Years
BS-AI	Computer Science	Artificial Intelligence - AI
4 Years
BS-Economics	Business Administration	Economics	4 Years
BS Mathematics	Mathematics	Mathematics	4 Years
BS-Media & Communication	Media & Communication	Media & Communication	4 Years
BS-Physical Education	Physical Education	Physical Education	4 Years
Associate Degree (AD)	Physical Education	Physical Education	2 Years
BE	Electrical Engineering	Electronics
Power
Energy Systems Engineering (Renewable)
4 Years
BE-Computer System Engineeering	Computer System Engineeering	Computer System Engineeering
4 Years
B.Ed 2.5 years Extension	Education	Education	2.5 - Years
B.Ed (Hons)	Education<	Education
4 - Years
Faculty
All PhDs
Management Science
Computer Science
Electrical Engineering
Education
Mathematics
Support Faculty
Focal Person
Mr. Muhammad Ali Shaikh
Assistant Manager (Admissions)
m-ali@iba-suk.edu.pk / admission@iba-suk.edu.pk
Telephone: 071-5644219, 071-5644218, 071-5644276



Home Summer Program
Summer Program
Why join our Summer Program?
Sukkur IBA University, known for the quality education, enviable acadmic environment and wonderful infrastructure, invites you to enroll in Summer Program. Our Summer Program offers an opportunity to the Business Executives, Managers, Professionals and Students to enhance their skills, refresh their knowledge and take advance credeits and cover academic deficiencies. The objective of our summer program is to provide you an opportunity to recieve intensive academic training from expert academicians in the field of your choice. We offer comprehensive range of courses in different fields.

Our Summer Program has a number of advantages and there are several reasons why you should attend this. Below are a few of the areas where we believe our strengths lie.

Who can apply for Summer Program
Students enrolled/graduated in any HEC recognized University/DAIs
Professionals graduated from any HEC recognized University DAIs
Sukkur IBA University undergraduate and MBA students
Course Fee Rs. 15,000/- (Per Course)
Students may take maximum 3 courses.
Courses will be offered subject to registration of minimum five students
Admission to the professionals will be offered as per their fields of specialization
Areas of Study
Accounting
Principles of Accounting-I
Principles of Accounting-II
Financial Accounting-I
Financial Accounting & Information
Fundamentals of Managerial Accounting
Managerial Accounting
Managerial Accounting for Decision Making
Corporate Accounting
Management
Finance
Social Sciences & Others
Marketing
Human Resource Management
Economics
Computer Science
Mathematics and Statistics
Electrical Engineering
English & Communication





Sukkur IBAâ€™s aims and objectives are to produce world class graduates who can globally compete, possess high ethical values and work for the betterment of society. The challenge has been to continue the emphasis on:

The mission of PhD Program is to develop scholars with the ability to create and imparting knowledge by creating a research environment, which encourages original, relevant, and rigorous research.
Program	Department	Major
Ph.D. Program	Management Science	Management
Ph.D. Program	Computer Science	Computer
Ph.D. Program	Electrical Engineering	Electrical Engineering
Ph.D. Program	Mathematics	Mathematics



Graduate Programs
Introduction
You are probably already aware that Sukkur Institute of Business Administration is ranked in top five Business Institutes of Pakistan. Sukkur IBA believes on Merit, Quality and Excellence. Sukkur IBA has never compromised quality in its standard of student intake. Sukkur IBAâ€™s aims and objectives are to produce world class graduates who can globally compete, possess high ethical values and work for the betterment of society. The challenge has been to continue the emphasis on:

Quality education at an affordable cost.
Association with reputed national and foreign institutions and industries.
Raises the standard of education through a unique foundation semester
To produce world class graduates who posses not only knowledge but also be equipped with practical skills and research capabilities and critical thinking.
Course Name	Department	Major	Length
M. Phil	Education	Education
2 Years
MBA 2 years	Business Administration	Marketing
HRM
Finace
2 Years
MS	Computer Science	Computer Science - CS
Software Engineering - SE
2 Years
Management Science	Management Science	2 Years
Mathematics	Applied Mathematics	2 Years
ME-Electrical Engineering	Electrical Engineering	Power
Electronics System Design
Communication & Signal Processing
Renewable Energy Systems
2 Years
Ultimately, all admissions decisions are based on academic criteria, test and interview results. To try to ensure that all applicants access up-to-date and factually correct information, we provide exhaustive information about all aspects of our admissions procedures through our extensive range of publications and our website. The Sukkur IBA offers full-time Business Programs, Information Technology Programs, Engineering Programs, Education Management Programs, Summer Programs, Foundation Course and Short Courses at Campus. It is not uncommon to find entrepreneurs, practicing, government employees, executives and professional and technocrats all attending these programs. The diversity in their work backgrounds makes interaction, inside as well as outside the class, a rich and educative experience. Specialized education programs are conducted for professionals from the corporate world. The admission policy and procedure acquaint the students with rules, policies and services provided by different departments of the Institute. It provides guidelines to students to know the different programs offered, their eligibility criteria and registration and enrollment process

Every applicant is considered individually in an holistic assessment using all the information available to us:

Their academic record
Test results, where a written test forms part of the assessment;
Performance at interview, if interviewed.




Foundation Program
Introduction
Sukkur IBA offers admission in foundation semester annually. This program is to enhance the skills of the students coming from diverse academic backgrounds.
The selected candidates will be taught through modern teaching methodology. Following subjects will be taught in Six (6) Months Foundation Semester

English
Mathematics
Information & Communication Technology-ICT
Note: The students who secure a minimum CGPA of 2.2 in foundation semester will be offered admissions in regular program in:
STHP and NTHP are the scholarships that are offered to the students who will pass the test and do foundation semester




GOLDEN OPPORTUNITY FOR TALENTED STUDENTS OF
SINDH PROVINCE
SINDH TALENT HUNT PROGRAM
2025
(Main Campus)
A life transforming opportunity for talented students of Sindh Province. 200 candidates will be offered admission to STHP Foundation Semester and taught the following courses.
1. English
2. Mathematics
3. Information & Communication Technologies (ICT)
From 200 students, who secure a minimum GPA of 2.2 will be eligible for the admission to undergraduate degree programs. However, top 700 performing students will be offered admission in undergraduate degree programs with 100% semester fee waiver and Rs. 5000/-stipend per month in each semester (Fall/Spring) for the period of 04 years.
DEGREE PROGRAMS
ВВА
BS
B.Ed
BE-Electrical Engineering
- Computer Science
• Power
BS
• Software Engineering
• Accounting and Finance
- Computer Science
BS
• Electronics
• Telecommunication
• Media and Communication
Specialization in
• Physical Education
• Mathematics
Artificial Intelligence
and Sports Sciences
BE
• Computer Systems Engineering
Selection Criteria
Main features of the program for
• Candidates must have Intermediate OR
Foundation Semester
Equivalent from any board in the years,
- No tuition fee
2022, 2023 & 2024.
• Free of cost books
• Candidates must have the domicile of Sindh
- Free of cost University bus/point facility is available
Province.
within Sukkur/Rohri on designated routes.
• Selection will be made on merit-cum need
For STHP Foundation Semester:
basis.
Hostel facility is not available, however, Rs. 5000
For Eligibility Criteria:
per month for living cost and Rs. 4000/- per
https://iba-suk.edu.pk/admissions/announcements
month stipend will be paid to selected candidates.
APPLY ONLINE: http://applyadmission.iba-suk.edu.pk
IMPORTANT DATES
TEST CENTERS
Last Date to Apply: December 06, 2024
• Sukkur
• Karachi
• Larkana
Admission Test
= December 15, 2024
• Hyderabad • Mirpurkhas
• Naushahro
Classes From
: January, 2025





OGDCL-NATIONAL TALENT HUNT PROGRAM 2024
AT SUKKUR IBA UNIVERSITY
(MAIN CAMPUS)
SUKKUR
IBA
UNIVERSITY
IBA
University
EMPOWER YOUR FUTURE WITH QUALITY EDUCATION!
EXTENSION OF DEADLINE TO APPLY
Last date of form submission : 08* November, 2024
Admission test : 17 November, 2024
Classes from January, 2025
For admission test centers, please visit: http://nthp.iba-suk.edu.pk
SELECTION CRITERIA:
• Candidates must have Intermediate/F.Sc/A-Level from any School/College in the years, 2022, 2023 & 2024.
• Selection will be made on merit-cum need basis.
• Candidates from districts identified by the Oil and Gas Development Company Limited (OGDCL) are eligible. (for list of Districts and details, please visit: http://nthp.iba-suk.edu.pk)
ELIGIBILITY CRITERIA:
•For BBA/BS/B.Ed Programs: Candidates must have Intermediate / F.Sc in with a minimum of 50% marks passed
in annual examination with no supplement by Board.
•For BE-Electrical and Computer Systems Engineering Programs: Candidates must have Intermediate / F.Sc in Pre-Engineering/Computer Science (ICS) group/A-Level in relevant subjects or 3 Years DAE in relevant held with a minimum of 60% marks passed in annual examination with no supplement by Board.
•For BS Mathematics Programs: Candidates must have Intermediate / F.Sc in Pre-Engineering or Computer
Science group with a minimum of 50% marks passed in annual examination with no supplement by Board.
WORLD
UNIVERSITY
RANKIN CS
CONNECT RAPID
АССА
CA
ARGISA
Apply Online: http://applyadmission.iba-suk.edu.pk
For further information please contact:
SUKKUR IBA UNIVERSITY Nisar Ahmed Siddiqui Road, Sukkur-65200.
Emall: nthp24@lba-suk.edu.pk Phone # 071-5644276,5644218, 5644219
Mobile # 03331116931, 03331116932
Sukkur IBA University
Merit-Quality-Excellence
OGDCL - National Talent Hunt Program 2024
Province Wise List of Districts

1. Sindh
Badin
Ghotki
Hyderabad
Jam Shoro
Thatta
Khairpur
Sanghar
Sukkur
Tando Allah Yar
Tando Muhammad Khan
Sujawal

2. Punjab
Attock
Chakwal
Dera Ghazi Khan
Rahim Yar Khan


3. KPK
Karak
Kohat
Laki Marwat
Orakzai Agency

4. Baluchistan
Dera Bugti
Jhal Magsi

5. Gilgit Baltistan
All Districts

6. Azad Jammu & Kashmir
All Districts

Province Wise Districts for Admission Test Centers

1. Sindh
Sukkur and Hyderabad

2. Punjab
Rahim Yar Khan & Chakwal

3. КРК
Kohat

4. Baluchistan
Sui & Jhal Maghsi

5. Gilgit Baltistan
Gilgit and Skardu

6. Azad Jammu & Kashmir
Mirpur and Muzaffarabad


Department of Business Administration

BBA
Candidate must have Intermediate / F.Sc with a minimum of 50% marks 
passed in annual examination with no supplement and no subject (s) condoned 
by Board OR A level (at least an average of ‘C’ grade in three principal 
subjects) OR American High School Diploma (with minimum of 60%) OR
An international Baccalaureate (at least 28 points out of 45).

BBA-Agribusiness
Candidate must have Intermediate / F.Sc with a minimum of 50% marks 
passed in annual examination with no supplement and no subject (s) condoned 
by Board OR A level (at least an average of ‘C’ grade in three principal
subjects) OR American High School Diploma (with minimum of 60%) OR 
An international Baccalaureate (at least 28 points out of 45).

BS-Accounting & Finance
Candidate must have Intermediate / F.Sc with a minimum of 50% marks 
passed in annual examination with no supplement and no subject (s) condoned 
by Board OR A level (at least an average of ‘C’ grade in three principal 
subjects) OR American High School Diploma (with minimum of 60%) OR
An international Baccalaureate (at least 28 points out of 45).

BS-Economics
Candidate must have Intermediate / F.Sc with a minimum of 50% marks 
passed in annual examination with no supplement and no subject (s) condoned 
by Board OR A level (at least an average of ‘C’ grade in three principal 
subjects) OR American High School Diploma (with minimum of 60%) OR
An international Baccalaureate (at least 28 points out of 45).

Department of Computer Science

Computer Science
Candidate must have Intermediate / F.Sc with a minimum of 50% marks 
passed in annual examination with no supplement and no subject (s) condoned 
by Board OR A level (at least an average of ‘C’ grade in three principal 
subjects) OR American High School Diploma (with minimum of 60%) OR
An international Baccalaureate (at least 28 points out of 45).

BS (Software Engineering)
Candidate must have Intermediate / F.Sc with a minimum of 50% marks 
passed in annual examination with no supplement and no subject (s) condoned 
by Board OR A level (at least an average of ‘C’ grade in three principal
subjects) OR American High School Diploma (with minimum of 60%) OR 
An international Baccalaureate (at least 28 points out of 45).

BS Computer Science Specialization in (A.I)
Candidate must have Intermediate / F.Sc with a minimum of 50% marks 
passed in annual examination with no supplement and no subject (s) condoned 
by Board OR A level (at least an average of ‘C’ grade in three principal 
subjects) OR American High School Diploma (with minimum of 60%) OR
An international Baccalaureate (at least 28 points out of 45).


Department of Electrical Engineering

BE Electrical Engineering
Candidate must have Intermediate / F.Sc in Pre-Engineering group or DAE 
with a minimum of 60% marks passed in annual examination with no
supplement and no subject (s) condonation by Board.


Department of Education Management

B.Ed (Hons) Elementary
Candidate must have Intermediate / F.Sc with a minimum of 50% marks 
passed in annual examination with no supplement and no subject (s) condoned 
by Board OR A level (at least an average of ‘C’ grade in three principal 
subjects) OR American High School Diploma (with minimum of 60%) OR
An international Baccalaureate (at least 28 points out of 45).

Department of Mathematics

BS(Mathematics)
Candidate must have Intermediate / F.Sc with a minimum of 50% marks passed 
in annual examination with no supplement and no subject (s) condoned by 
Board OR A level (at least an average of ‘C’ grade in three principal subjects) 
OR American High School Diploma (with minimum of 60%) OR An
International Baccalaureate (at least 28 points out of 45).

Department of Physical Education

BS(physical education)
Candidate must have Intermediate / F.Sc with a minimum of 50% marks passed 
in annual examination with no supplement and no subject (s) condoned by 
Board OR A level (at least an average of ‘C’ grade in three principal subjects) 
OR American High School Diploma (with minimum of 60%) OR An
International Baccalaureate (at least 28 points out of 45).

Department of Computer System Engineering

BE (Computer System Engineering)
Candidate must have Intermediate / F.Sc in Pre-Engineering group or DAE 
with a minimum of 60% marks passed in annual examination with no
supplement and no subject (s) condonation by Board.

NOte: students who can completed there intermediate in 2022, 2023, and 2024 can apply for the test in 2024 



Contact Us
Sukkur IBA University
Nisar Ahmed Siddiqui Road

Sukkur Sindh, Pakistan
Telephone: 071-5644000 / 05
Email: info@iba-suk.edu.pk`